import { BranchSelectorFallback } from '@/components/form/branch-selector/fallback'
import { RepositorySelectorFallback } from '@/components/form/repository-selector/fallback'
import { Skeleton } from '@/components/ui/skeleton'

type Props = {
  showBranchSelector?: boolean
}

export const PrivateGitSelectorFallback = ({ showBranchSelector }: Props) => (
  <div className="flex flex-col gap-3 w-full">
    <Skeleton className="h-3 w-[80px]" />
    <Skeleton className="h-9 w-3/8 mb-3.5" />
    {showBranchSelector ? (
      <div className="grid gap-4 grid-cols-3 items-end">
        <div className="col-span-2">
          <RepositorySelectorFallback />
        </div>
        <div className="col-span-1">
          <BranchSelectorFallback />
        </div>
      </div>
    ) : (
      <RepositorySelectorFallback />
    )}
    <Skeleton className="h-2.5 w-[40%]" />
  </div>
)
